import _ from 'underscore';
import ko from 'knockout';
import { PureKnockoutView } from '@bingads-webui/knockout-view';
import { KoSchema } from '@bingads-webui/ko-schema';
import { toDec } from '@bingads-webui-universal/primitive-utilities';
import template from './create-template.pug';

/**
 * create event - When save button clicked, it fires with the new label settings
 *
 * @event CreateLabelView#create
 * @type {void}
*/

/**
 * cancel event - When cancel button clicked, it fires cancel event.
 *
 * @event CreateLabelView#cancel
 * @type {void}
 */

/**
 * CreateLabelView: label create view
 * Trigger event CreateLabelView#create
 * Trigger event CreateLabelView#cancel
*/
export class CreateLabelView extends PureKnockoutView {
  /**
   * Initialize view settings
   *
   * @param {Object} param - An object containing these default options for view:
   * @param {Object} param.i18n - the localization settings
   * @param {Object} param.i18n.getString - localization settings function
   * @param {Object} param.s$label - schema for label
   * @param {Object} param.i18nErrors - odata error settings
   * @param {Object} param.i18nErrors.getODataErrors - function to convert odataerrors
   * @returns {void} void
   */
  initialize({
    s$label,
    i18n,
    i18nErrors,
    isForVNext = false,
  }) {
    this.options = {
      s$label,
      i18n,
      i18nErrors,
      isForVNext,
    };

    super.initialize(this.options);

    const {
      instance, schema, keys, model, customValidators,
    } = {
      instance: this.viewModel,
      schema: s$label,
      keys: ['Name'],
      model: {},
    };

    KoSchema(instance, schema, keys, model, customValidators, i18n);
  }

  get className() {
    return 'create-label';
  }

  get events() {
    return {
      'click .create-label__action[data-action="create"]': this.onCreate,
      'click .create-label__action[data-action="cancel"]': this.onCancel,
    };
  }

  get template() {
    return ({ model }) => template(_.extend({}, model, {
      i18n: this.options.i18n,
      isForVNext: this.options.isForVNext,
    }));
  }

  /**
   * Set errors for create view, view will update the message accordingly
   *
   * @param {Array[]} errors - errors for the view
   * @returns {void}
   */
  setErrors(errors) {
    this.viewModel.errors.add(this.options.i18nErrors.getODataErrors(errors));
  }


  /**
   * Fires create event after click apply button
   *
   * @fires CreateLabelView#create
   * @returns {void}
   */
  onCreate() {
    const isValid = this.viewModel.Name.validate();

    if (isValid) {
      const dto = ko.toJS(this.viewModel);

      this.trigger('create', {
        Name: dto.Name,
        Description: '',
        ColorCode: toDec(`#${Math.random().toString(16).slice(-6)}`),
      });
    }
  }

  /**
   * Fires cancel event after click cancel button
   *
   * @fires CreateLabelView#cancel
   * @returns {void}
   */
  onCancel() {
    this.trigger('cancel');
  }
}
